export const LoginStatusStorage = {
    isCheck: false
};
//# sourceMappingURL=LoginStatusStorage.js.map